<template>
  <div class="plat-form-wrap">
    <Banner></Banner>
    <!--banner和搜索-->
    <div class="body-wrap home-mini-width">
      <a-row>
        <a-col :span="24">
          <Infomate></Infomate>
          <!--综合资讯-->
          <InformationAnalysis></InformationAnalysis>
          <!--专利信息分析-->
          <HumanIntelligence></HumanIntelligence>
          <!--人才智库-->
          <knowledge-training></knowledge-training>
          <!--知产培训-->
          <FriendShip></FriendShip>
          <!--友情培训-->
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
import Banner from './components/banner.vue'
import Infomate from './components/infomate.vue'
import InformationAnalysis from "./components/informationAnalysis.vue";
import HumanIntelligence from './components/humanIntelligence.vue'
import KnowledgeTraining from './components/knowledgeTraining.vue'
import FriendShip from './components/friendShip.vue'

export default {
  data() {
    return {}
  },
  components: {
    Banner,
    Infomate,
    InformationAnalysis,
    HumanIntelligence,
    KnowledgeTraining,
    FriendShip
  },
  mounted() {},
  methods: {
  },
}
</script>
